var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat"},[_c('Breadcrumb',{attrs:{"title":"ReadWrite_Chat","items":_vm.items}}),_c('chat-comp',{attrs:{"chatObj":_vm.singleChat}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }